import type { LoginOptions, ProductKey } from '@traceio-org/platform-contracts';

/** Self-serve sign-up is for Trace Enterprise only (spec 2026-10-18 decision 1). */
export const SIGNUP_PRODUCT: ProductKey = 'enterprise';

/**
 * The identity provider connection the sign-up screens open on (platform-api's loginOptions.signup, which carries
 * the work email rule), or null when sign-up is not offered: no such connection, or no identity provider configured.
 * Shared by /signup and the start page's "Use a different account", so both open the same screens.
 */
export function signupConnection(options: LoginOptions): string | null {
  return options.identityProvider.configured ? (options.signup?.connection ?? null) : null;
}
